import axios from 'axios'

export default {
    namespaced: true,
    
    state: () => ({
        labelData: [],
        labelsAreLoading: false,
        labelAvailable: true,
        allLabels: [],
        labelRequest: [],
        labelError: null,
        pendingLabelRequest: null,
        pendingLabelRequestGroup: null
    }),
    
    getters: {
        getProductLabelData: (state) => (offerName) => {
            if (!state.labelData || !Array.isArray(state.labelData)) return false;
            
            try {
                const matchedData = state.labelData.flat().find(data =>
                    data?.labels?.some(label => label.name === offerName)
                );
                return matchedData || false;
            } catch (error) {
                console.error('Error in getProductLabelData:', error);
                return false;
            }
        },
    },
    
    mutations: {
        STORE_LABEL(state, payload) {
            const data = Array.isArray(payload) ? payload.flat(2) : [payload];

            if (state.labelData.length >= 4) {
                state.labelData = [];
            }

            state.labelData = [...state.labelData, ...data];
        },

        RESET_LABELS(state){
            state.labelData = [];
        },

        ALL_LABELS(state, payload) {
            const existingIndex = state.allLabels.findIndex(label => label.planName === payload.planName);
    
            if (existingIndex !== -1) {
                return
            } else {
                // Reset array if it's reached max size before adding new label
                if (state.allLabels.length >= 4) {
                    state.allLabels = [];
                }
                state.allLabels.push(payload);
            }
        },

        UPDATE_LABEL_REQUEST(state, planName) {
            state.labelRequest = [];
            state.labelRequest = state.allLabels.filter(request => 
                request.planName === planName
            );
        },

        RESET_ALL_LABELS(state) {
            state.allLabels = [];
            state.labelRequest = [];
        },
        
        CHANGE_LOADING_STATE(state, loading) {
            state.labelsAreLoading = loading;
        },
        
        RESTORE_LABELS(state, payload) {  
            state.labelData = payload.labelData || []; 
        },
        
        SET_LABEL_STATUS(state, available) {
            state.labelAvailable = available;
        },
        
        SET_LABEL_ERROR(state, error) {
            state.labelError = error;
            state.labelAvailable = false;
        },

        // Store the plan name for selected product
        SET_PENDING_LABEL_REQUEST(state, planName) {
            state.pendingLabelRequest = planName;
        },

        // Store the request objects for processing  
        SET_PENDING_LABEL_REQUEST_GROUP(state, requestArray) {
            if (Array.isArray(requestArray)) {
                state.pendingLabelRequestGroup = requestArray;
            } else if (requestArray) {
                // convert single request to array
                state.pendingLabelRequestGroup = [requestArray];
            } else {
                state.pendingLabelRequestGroup = null;
            }
        },
        
        CLEAR_PENDING_LABEL_REQUEST(state) {
            state.pendingLabelRequest = null;
            state.pendingLabelRequestGroup = null;
        }
    },
    
    actions: {
        async fetchBroadbandLabel({ commit, state }, payload) {  
            try {
                commit('ALL_LABELS', payload);
                commit('CHANGE_LOADING_STATE', true);

                const response = await axios.post('/api/actifai/labels', payload, {
                    timeout: 15000,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response?.data) {
                    commit('SET_LABEL_STATUS', true);
                    commit('STORE_LABEL', response.data);
                } else {
                    throw new Error('Invalid response data');
                }
                
            } catch (error) {
                console.error('labelStore.js: Error fetching broadband label:', error);
                commit('SET_LABEL_ERROR', error.message || 'Failed to load label data');
                commit('SET_LABEL_STATUS', false);
                
            } finally {
                commit('CHANGE_LOADING_STATE', false);
            }
        },

        updateLabelRequest({ commit }, planName) {
            commit('UPDATE_LABEL_REQUEST', planName);
        },
        
        setLabelStatus({ commit }, payload) {
            commit('SET_LABEL_STATUS', payload);
        },
        
        setLoadingState({ commit }, payload) {
            commit('CHANGE_LOADING_STATE', payload);
        },

        resetAllLabels({ commit }) {
            commit('RESET_ALL_LABELS');
        },
        
        resetLabels({ commit }) {
            commit('RESET_LABELS');
        },

        // Saves selected plan name (string)
        savePendingLabelRequest({ commit }, planName) {
            commit('SET_PENDING_LABEL_REQUEST', planName);
        },

        // Saves request objects array
        savePendingLabelRequestGroup({ commit }, requestArray) {
            commit('SET_PENDING_LABEL_REQUEST_GROUP', requestArray);
        },
        
        async processPendingLabelRequests({ state, dispatch, commit }) {
            if (!state.pendingLabelRequestGroup || !Array.isArray(state.pendingLabelRequestGroup) || state.pendingLabelRequestGroup.length === 0) {
                return;
            }
      
            try {
                const promises = state.pendingLabelRequestGroup.map(request => {
                    return dispatch('fetchBroadbandLabel', request);
                });
                
                await Promise.all(promises);

                let pendingRequest = state.pendingLabelRequest;
                dispatch('updateLabelRequest', pendingRequest);
             
            } catch (error) {
                console.error('Error processing pending label requests:', error);
                throw error;
            } finally {
                // Clear both properties after processing
                commit('CLEAR_PENDING_LABEL_REQUEST');
            }
        }
    }
}